module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAM1BMVEVKrdZ1uaT/3gBUsMp/u5jm1x733Am/zUvs2ReVwX5ascOXwnttt6zT0jSexHPg1iXIz0Ev526rAAAAvUlEQVR4Ae3YhRECARTE0E9wp/9qGcedzNmmgYecbqWUUkppKI04b/x/YHIBGAyP8gVg+hdhxvPm//oS5ldZ8E4/EUuwEd5u9S2xBnC/yQZ0BHSED9v6BOx8A3wC5r4BPgGzDw39i+zwDb5s7xvg/1Tgfw04+Ab8wYgRI0aMQ6uuu9VmY9+y+3m115iVjzTxvCsgbXj/EN6jBKS177X++7m/M/h7ib/7yPuVsMMJe6Kg+Puuv1OnlFJKaWAdATcvFuUyhjKKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/palau.png
// module id = 633
// module chunks = 0